'use client';
import Collections, { CollectionsProps } from './Collections';
import useVaultCollections from '@/application/read/collections/useVaultCollections';

export interface CollectionsContainerProps
  extends Omit<CollectionsProps, 'collections'> {}

const CollectionsContainer = ({}: CollectionsContainerProps) => {
  const { data: collections } = useVaultCollections();

  return <Collections collections={collections} isLoading={!collections} />;
};

export default CollectionsContainer;
